function formatKlarnaMoney(cents, currency, locale) {
  try {
    return new Intl.NumberFormat(locale || undefined, {
      style: 'currency',
      currency
    }).format(cents / 100);
  } catch (error) {
    return `£${(cents / 100).toFixed(2)}`;
  }
}

function updateKlarnaPaymentMessages(root = document) {
  root.querySelectorAll('[data-klarna-payment-message]').forEach((message) => {
    const amountEl = message.querySelector('[data-klarna-payment-amount]');
    const price = Number(message.dataset.klarnaPrice);
    const paymentCount = Number(message.dataset.klarnaPayments) || 3;

    if (!amountEl || !price || Number.isNaN(price)) return;

    const splitPrice = Math.floor(price / paymentCount);
    amountEl.textContent = formatKlarnaMoney(
      splitPrice,
      message.dataset.klarnaCurrency || window.Shopify?.currency?.active || 'GBP',
      message.dataset.klarnaLocale || document.documentElement.lang || 'en-GB'
    );
  });
}

class PaymentAppSlider extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.track = this.querySelector('.payment-app-slider__track');
    this.slides = Array.from(this.querySelectorAll('.payment-app-slider__slide'));

    if (!this.track || this.slides.length < 2) return;

    this.dataset.initialized = 'true';
    this.intervalDelay = Number(this.dataset.interval) || 3000;
    this.isAnimating = false;
    this.onTransitionEnd = this.handleTransitionEnd.bind(this);

    this.track.addEventListener('transitionend', this.onTransitionEnd);

    updateKlarnaPaymentMessages(this);

    this.start();

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());
  }

  disconnectedCallback() {
    this.stop();
    this.track?.removeEventListener('transitionend', this.onTransitionEnd);
  }

  start() {
    if (this.timer || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.timer = window.setInterval(() => this.next(), this.intervalDelay);
  }

  stop() {
    window.clearInterval(this.timer);
    this.timer = null;
  }

  next() {
    if (this.isAnimating) return;

    this.isAnimating = true;
    this.track.style.transition = '';
    this.track.style.transform = 'translateX(-100%)';
  }

  handleTransitionEnd(event) {
    if (event.target !== this.track || event.propertyName !== 'transform') return;

    this.track.append(this.track.firstElementChild);
    this.track.style.transition = 'none';
    this.track.style.transform = 'translateX(0)';
    this.track.offsetHeight;
    this.track.style.transition = '';
    this.isAnimating = false;
  }
}

if (!customElements.get('payment-app-slider')) {
  customElements.define('payment-app-slider', PaymentAppSlider);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => updateKlarnaPaymentMessages(), { once: true });
} else {
  updateKlarnaPaymentMessages();
}

document.addEventListener('shopify:section:load', (event) => updateKlarnaPaymentMessages(event.target));
document.addEventListener('on:variant:change', (event) => {
  const variant = event.detail?.variant;
  if (!variant?.price) return;

  const scope = event.target.closest('.product-info') || document;
  scope.querySelectorAll('[data-klarna-payment-message]').forEach((message) => {
    message.dataset.klarnaPrice = variant.price;
  });
  updateKlarnaPaymentMessages(scope);
});
